/**
 * Resuelve la URL final de una imagen guardada en BD.
 *
 *   - Si empieza con http(s): usar tal cual (URL absoluta)
 *   - Si empieza con "/" : es subida al backend, prepender REACT_APP_BACKEND_URL
 *   - Si es solo nombre de archivo: legacy, prepender legacyBase (nayaceros.com/...)
 */
export const resolveImage = (value, legacyBase = '') => {
  if (!value) return null;
  const v = String(value).trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  if (v.startsWith('/')) {
    const backend = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
    return `${backend}${v}`;
  }
  return `${legacyBase}${v}`;
};

export const PRODUCT_IMAGE_BASE  = '/images/productos/';
export const SERVICE_IMAGE_BASE  = '/images/servicios/';
export const PROCESS_IMAGE_BASE  = '/images/procesos/';
export const SUPPLIER_IMAGE_BASE = '/images/proveedores/';
